var _excluded = ["id", "onSelect", "transition", "mountOnEnter", "unmountOnExit", "variant", "children", "activeKey"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useUncontrolled } from 'uncontrollable';
import BaseTabs from '@restart/ui/Tabs';
import Nav from './Nav';
import NavLink from './NavLink';
import NavItem from './NavItem';
import TabContent from './TabContent';
import TabPane from './TabPane';
import { forEach, map } from './ElementChildren';
import getTabTransitionComponent from './getTabTransitionComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getDefaultActiveKey(children) {
  var defaultActiveKey;
  forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}
function renderTab(child) {
  var _child$props = child.props,
    title = _child$props.title,
    eventKey = _child$props.eventKey,
    disabled = _child$props.disabled,
    tabClassName = _child$props.tabClassName,
    tabAttrs = _child$props.tabAttrs,
    id = _child$props.id;
  if (title == null) {
    return null;
  }
  return /*#__PURE__*/_jsx(NavItem, {
    as: "li",
    role: "presentation",
    children: /*#__PURE__*/_jsx(NavLink, _objectSpread(_objectSpread({
      as: "button",
      type: "button",
      eventKey: eventKey,
      disabled: disabled,
      id: id,
      className: tabClassName
    }, tabAttrs), {}, {
      children: title
    }))
  });
}
var Tabs = function Tabs(props) {
  var _useUncontrolled = useUncontrolled(props, {
      activeKey: 'onSelect'
    }),
    id = _useUncontrolled.id,
    onSelect = _useUncontrolled.onSelect,
    transition = _useUncontrolled.transition,
    _useUncontrolled$moun = _useUncontrolled.mountOnEnter,
    mountOnEnter = _useUncontrolled$moun === void 0 ? false : _useUncontrolled$moun,
    _useUncontrolled$unmo = _useUncontrolled.unmountOnExit,
    unmountOnExit = _useUncontrolled$unmo === void 0 ? false : _useUncontrolled$unmo,
    _useUncontrolled$vari = _useUncontrolled.variant,
    variant = _useUncontrolled$vari === void 0 ? 'tabs' : _useUncontrolled$vari,
    children = _useUncontrolled.children,
    _useUncontrolled$acti = _useUncontrolled.activeKey,
    activeKey = _useUncontrolled$acti === void 0 ? getDefaultActiveKey(children) : _useUncontrolled$acti,
    controlledProps = _objectWithoutProperties(_useUncontrolled, _excluded);
  return /*#__PURE__*/_jsxs(BaseTabs, {
    id: id,
    activeKey: activeKey,
    onSelect: onSelect,
    transition: getTabTransitionComponent(transition),
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    children: [/*#__PURE__*/_jsx(Nav, _objectSpread(_objectSpread({}, controlledProps), {}, {
      role: "tablist",
      as: "ul",
      variant: variant,
      children: map(children, renderTab)
    })), /*#__PURE__*/_jsx(TabContent, {
      children: map(children, function (child) {
        var childProps = _objectSpread({}, child.props);
        delete childProps.title;
        delete childProps.disabled;
        delete childProps.tabClassName;
        delete childProps.tabAttrs;
        return /*#__PURE__*/_jsx(TabPane, _objectSpread({}, childProps));
      })
    })]
  });
};
Tabs.displayName = 'Tabs';
export default Tabs;